import { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { Clock, CheckCircle } from 'lucide-react';

interface BusinessCooldownTimerProps {
  cooldownRemaining: number;
  canCollect: boolean;
}

function formatTime(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return `${h}h ${m}m ${s}s`;
}

export function BusinessCooldownTimer({
  cooldownRemaining,
  canCollect,
}: BusinessCooldownTimerProps) {
  const [remaining, setRemaining] = useState(cooldownRemaining);

  useEffect(() => {
    setRemaining(cooldownRemaining);
  }, [cooldownRemaining]);

  useEffect(() => {
    if (remaining <= 0) return;
    const timer = setInterval(() => {
      setRemaining((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [remaining]);

  if (canCollect && remaining <= 0) {
    return (
      <Badge variant="default" className="gap-1">
        <CheckCircle className="h-3 w-3" />
        Ready
      </Badge>
    );
  }

  return (
    <Badge variant="secondary" className="gap-1">
      <Clock className="h-3 w-3" />
      {formatTime(remaining)}
    </Badge>
  );
}
